export class ClassRequestModel {
    classId: number;
    constructor(classId: number) {
        this.classId = classId;
    }
}